import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "bg-white shadow-none lg:shadow-lg rounded-none lg:rounded-xl p-6 font-roboto border-l-0 border-r-0 lg:border border-gray-200" };
const _hoisted_2 = { class: "flex items-center justify-between mb-4" };
const _hoisted_3 = { class: "space-y-4" };
const _hoisted_4 = { class: "flex gap-4" };
const _hoisted_5 = { class: "flex-shrink-0" };
const _hoisted_6 = ["src", "alt", "onError"];
const _hoisted_7 = { class: "flex-1 min-w-0" };
const _hoisted_8 = { class: "font-semibold text-gray-900 truncate pr-2" };
const _hoisted_9 = {
    key: 0,
    class: "text-sm text-gray-600"
};
const _hoisted_10 = { key: 1 };
const _hoisted_11 = {
    key: 0,
    class: "mb-2"
};
const _hoisted_12 = { class: "flex flex-wrap gap-1" };
const _hoisted_13 = { key: 1 };
const _hoisted_14 = { class: "flex flex-wrap gap-1" };
const _hoisted_15 = {
    key: 2,
    class: "mt-2"
};
const _hoisted_16 = { class: "flex flex-wrap gap-1" };
const _hoisted_17 = {
    key: 3,
    class: "mb-2"
};
const _hoisted_18 = { class: "text-xs text-gray-600 italic" };
const _hoisted_19 = { class: "flex items-center justify-between pt-2 border-t border-gray-200 mt-2" };
const _hoisted_20 = { class: "flex items-center gap-3" };
const _hoisted_21 = ["onClick", "title"];
const _hoisted_22 = { class: "w-10 text-center font-bold text-gray-900 bg-gray-100 rounded-lg px-3 py-2 text-lg" };
const _hoisted_23 = ["onClick"];
const _hoisted_24 = { class: "text-right" };
const _hoisted_25 = { class: "text-xs text-gray-500" };
const _hoisted_26 = {
    key: 0,
    class: "text-xs text-gray-400"
};
const _hoisted_27 = {
    key: 0,
    class: "mt-4 p-4 bg-amber-50 border border-amber-200 rounded-lg"
};
const _hoisted_28 = { class: "flex items-start" };
const _hoisted_29 = { class: "ml-3 flex w-full flex-col" };
const _hoisted_30 = { class: "space-y-1 w-full" };
const _hoisted_31 = { class: "flex justify-between" };
const _hoisted_32 = { class: "font-medium" };
const _hoisted_33 = { class: "mt-6 px-1" };
const _hoisted_34 = { class: "space-y-2" };
const _hoisted_35 = {
    key: 0,
    class: "flex justify-between text-sm text-green-600 font-medium"
};
const _hoisted_36 = { class: "flex items-center gap-2" };
const _hoisted_37 = {
    key: 1,
    class: "flex justify-between text-sm text-gray-600"
};
const _hoisted_38 = { class: "flex flex-col" };
const _hoisted_39 = {
    key: 1,
    class: "text-xs text-green-600 mt-1 font-medium"
};
const _hoisted_40 = {
    key: 0,
    class: "font-semibold text-gray-500"
};
const _hoisted_41 = { key: 1 };
const _hoisted_42 = {
    key: 2,
    class: "font-bold text-green-600"
};
const _hoisted_43 = {
    key: 2,
    class: "flex justify-between text-sm text-gray-600"
};
const _hoisted_44 = {
    key: 3,
    class: "flex justify-between text-sm text-gray-700 py-2 border-t border-gray-200"
};
const _hoisted_45 = { class: "font-medium" };
const _hoisted_46 = {
    key: 4,
    class: "text-xs text-gray-500 bg-gray-50 p-3 rounded-lg"
};
const _hoisted_47 = { class: "space-y-1" };
const _hoisted_48 = {
    key: 0,
    class: "border-t border-gray-300 pt-1 mt-2 font-medium flex justify-between"
};
const _hoisted_49 = { class: "flex justify-between text-lg font-bold text-gray-900 pt-2 border-t" };
import { ref, watch, computed, onMounted, onUnmounted, nextTick, inject } from "vue";
import { useOrderPricing } from "../../composables/useOrderPricing";
import { useCartStore } from "../../composables/useCartStore";
import { useCheckoutStore } from "@shared";
import { useProjectConfig } from "../../composables/useProjectConfig";
import CartMenuLine from '../menu/CartMenuLine.vue';
import defaultFoodImage from "@/assets/default-food-image.svg";
export default /*@__PURE__*/ _defineComponent({
    __name: 'OrderOverview',
    props: {
        items: {},
        subtotal: {},
        deliveryFee: {},
        serviceFee: {},
        totalAmount: {},
        orderType: {},
        formatPrice: { type: Function },
        discountInfo: {},
        taxBreakdown: {},
        taxCalculation: {},
        breakdown: {}
    },
    emits: ["updateQuantity", "removeItem"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        // ✅ USE PROJECT CONFIG: Get project ID dynamically
        const { projectId, config } = useProjectConfig();
        // Use shared pricing composable with dynamic project ID
        const orderPricing = useOrderPricing(projectId.value || 'default');
        // ✅ USE CHECKOUT STORE: For delivery address validation
        const checkoutStore = useCheckoutStore();
        // Get theme config - with fallback to default red
        const projectConfig = inject('projectConfig', null);
        const themePrimaryColor = computed(() => projectConfig?.branding?.colors?.primary || '#DC2626');
        const hasApiPricing = computed(() => {
            const pricing = orderPricing.pricingData.value?.data?.pricing;
            return typeof pricing?.totalCent === 'number';
        });
        const normalizeEuroValue = (value) => {
            if (typeof value === 'number' && Number.isFinite(value)) {
                return value;
            }
            if (typeof value === 'string') {
                const normalized = value.replace(/[^0-9,.-]/g, '').replace(',', '.');
                const parsed = Number.parseFloat(normalized);
                return Number.isFinite(parsed) ? parsed : 0;
            }
            return 0;
        };
        const displaySubtotal = computed(() => {
            return hasApiPricing.value
                ? Number(orderPricing.subtotal.value ?? 0)
                : normalizeEuroValue(props.subtotal);
        });
        const displayDeliveryFee = computed(() => {
            return hasApiPricing.value
                ? Number(orderPricing.deliveryFee.value ?? 0)
                : normalizeEuroValue(props.deliveryFee);
        });
        const isDeliveryFeeCalculating = computed(() => {
            if (props.orderType !== 'delivery')
                return false;
            return Boolean(orderPricing.isLoading.value) || Boolean(checkoutStore.isLoading);
        });
        const displayServiceFee = computed(() => {
            return hasApiPricing.value
                ? Number(orderPricing.serviceFee.value ?? 0)
                : normalizeEuroValue(props.serviceFee);
        });
        const displayTotalAmount = computed(() => {
            return hasApiPricing.value
                ? Number(orderPricing.total.value ?? 0)
                : normalizeEuroValue(props.totalAmount);
        });
        const freeDeliveryThreshold = computed(() => {
            const deliveryData = orderPricing.pricingData.value?.data?.delivery;
            // Wenn eine Server-Preisberechnung vorliegt, ist sie die Quelle der Wahrheit.
            // freeDeliveryThresholdCent ist null/0, wenn "Kostenlose Lieferung" im Portal
            // deaktiviert ist – in diesem Fall NICHT auf den statischen Projekt-Config-Wert
            // zurückfallen (sonst erscheint fälschlich "noch X€ für kostenfreie Lieferung").
            if (deliveryData) {
                const responseThresholdCent = deliveryData.freeDeliveryThresholdCent;
                if (typeof responseThresholdCent === 'number' && responseThresholdCent > 0) {
                    return responseThresholdCent / 100;
                }
                return null;
            }
            // Fallback auf die statische Projekt-Config nur, solange noch keine
            // Server-Berechnung vorliegt (z. B. initiales Rendern vor dem Pricing-Call).
            const configThresholdCent = config.services.delivery.freeDeliveryFrom;
            if (typeof configThresholdCent === 'number' && configThresholdCent > 0) {
                return configThresholdCent / 100;
            }
            return null;
        });
        // Get cart store for direct access to items (in case props are not yet available on page reload)
        const cartStore = useCartStore();
        // Destructure minimum order properties from orderPricing
        const { orderStatusMessage, minimumOrderInfo } = orderPricing;
        // ✅ MANUAL REFS: Fix broken reactivity for minimum order error (same approach as timing)
        const isMinimumOrderError = ref(false);
        // Function to update minimum order error manually
        const updateMinimumOrderError = () => {
            const pricingData = orderPricing.pricingData.value;
            const minOrderInfo = orderPricing.minimumOrderInfo.value;
            const currentSubtotal = displaySubtotal.value;
            // orderType wird für eventuelle Zukunftslogik reserviert
            // const orderType = props.orderType;
            // ✅ UPDATED: Check minimum order for BOTH pickup and delivery
            // Both order types can have minimum order requirements
            // ✅ UPDATED: Check minimum order for BOTH pickup and delivery orders
            // Method 1: Check explicit server error for minimum order
            const hasServerMinimumError = pricingData?.code === "MINIMUM_ORDER_NOT_REACHED";
            // Method 2: Check local calculation using CURRENT subtotal (not cached minimumOrderInfo.current)
            // Use normalized subtotal as source of truth, not minimumOrderInfo.current which may be stale
            const hasLocalMinimumError = minOrderInfo && currentSubtotal < minOrderInfo.required;
            // Method 3: Check isReached flag from API
            const hasApiMinimumError = minOrderInfo && !minOrderInfo.isReached;
            const result = hasServerMinimumError || hasLocalMinimumError || hasApiMinimumError;
            isMinimumOrderError.value = result;
        };
        // ✅ WATCH ORDER TYPE CHANGES: Update minimum order error when switching pickup/delivery
        watch(() => props.orderType, () => {
            updateMinimumOrderError();
        }, { immediate: true });
        // ✅ WATCH SUBTOTAL CHANGES: Update minimum order error when pricing data updates
        watch(displaySubtotal, () => {
            updateMinimumOrderError();
        }, { immediate: true });
        // ✅ WATCH ITEMS CHANGES: Update minimum order error when items are added/removed/modified
        watch(() => props.items, () => {
            updateMinimumOrderError();
        }, { immediate: true, deep: true });
        watch([orderStatusMessage, minimumOrderInfo], ([statusMessage, orderInfo]) => {
            console.log("🧾 OrderOverview - Minimum order values changed:", {
                statusMessage: statusMessage,
                orderInfo: orderInfo,
                hasPricingData: !!orderPricing.pricingData.value,
                pricingCode: orderPricing.pricingData.value?.code,
                pricingStatus: orderPricing.pricingData.value?.status,
            });
            // ✅ MANUAL UPDATE: Update minimum order error when data changes
            updateMinimumOrderError();
        }, { immediate: true, deep: true });
        // Also watch the raw pricing data to catch all changes + UPDATE MINIMUM ORDER ERROR
        watch(() => orderPricing.pricingData.value, (newPricingData) => {
            console.log("🧾 OrderOverview - Raw pricing data changed:", {
                hasPricingData: !!newPricingData,
                code: newPricingData?.code,
                status: newPricingData?.status,
                message: newPricingData?.message,
                data: newPricingData?.data,
            });
            // ✅ MANUAL UPDATE: Update minimum order error when pricing data changes
            updateMinimumOrderError();
            // Force re-evaluation of computed properties
            if (newPricingData?.code === "MINIMUM_ORDER_NOT_REACHED") {
                console.log("🧾 OrderOverview - Minimum order detected, forcing update:", {
                    orderStatusMessage: orderStatusMessage.value,
                    minimumOrderInfo: minimumOrderInfo.value,
                    isMinimumOrderError: isMinimumOrderError.value,
                });
            }
        }, { immediate: true, deep: true });
        // ✅ SYNC WITH CHECKOUT STORE: Listen to pricing changes event (same as checkout-store)
        onMounted(() => {
            const handlePricingChanged = () => {
                console.log("🧾 OrderOverview - orderPricingChanged event received");
                updateMinimumOrderError();
            };
            window.addEventListener('orderPricingChanged', handlePricingChanged);
            // Cleanup on unmount
            return () => {
                window.removeEventListener('orderPricingChanged', handlePricingChanged);
            };
        });
        // Free delivery message computation
        const freeDeliveryMessage = computed(() => {
            if (props.orderType !== 'delivery')
                return null;
            const threshold = freeDeliveryThreshold.value;
            const currentDeliveryFee = displayDeliveryFee.value;
            const currentSubtotal = displaySubtotal.value;
            if (!threshold || threshold <= 0) {
                return null;
            }
            if (currentDeliveryFee <= 0) {
                return null;
            }
            if (currentSubtotal >= threshold) {
                return null;
            }
            const missingAmount = threshold - currentSubtotal;
            if (missingAmount <= 0) {
                return null;
            }
            return `noch ${formatPrice(missingAmount)} für kostenfreie Lieferung`;
        });
        // Reason why delivery is free (zone threshold or global threshold)
        const freeDeliveryReason = computed(() => {
            if (props.orderType !== 'delivery' || displayDeliveryFee.value > 0) {
                return null;
            }
            const deliveryInfo = orderPricing.pricingData.value?.data?.delivery;
            if (!deliveryInfo || !deliveryInfo.isEligibleForFree) {
                return null;
            }
            // Check if zone-based free delivery
            if (deliveryInfo.reason === 'zone_free_delivery_threshold_reached') {
                return '🎉 Kostenlose Lieferung in Ihrer Zone erreicht!';
            }
            // Check if global free delivery
            if (deliveryInfo.reason === 'free_delivery_threshold_reached') {
                return 'Mindestbestellwert für kostenlose Lieferung erreicht';
            }
            return null;
        });
        // minimumOrderInfo ist bereits in orderPricing verfügbar
        // Local tax data copies to ensure persistence on page reload
        const localTaxBreakdown = ref({});
        const localTaxCalculation = ref(null);
        // ✅ IMMEDIATE INITIALIZATION: Extract tax data from current API response on mount
        const initializeTaxDataFromApi = () => {
            const currentPricingData = orderPricing.pricingData.value;
            console.log("🧾 [TAX DEBUG] initializeTaxDataFromApi called:", {
                hasPricingData: !!currentPricingData,
                hasDataObject: !!currentPricingData?.data,
                hasNewTaxStructure: !!currentPricingData?.data?.tax,
                taxTotalCent: currentPricingData?.data?.tax?.totalCent,
                taxServiceType: currentPricingData?.data?.tax?.serviceType,
                hasGermanTaxBreakdown: !!currentPricingData?.data?.tax?.breakdown,
                germanTaxBreakdown: currentPricingData?.data?.tax?.breakdown,
                hasLegacyPricing: !!currentPricingData?.data?.pricing,
                fullPricingData: currentPricingData
            });
            // ✅ PRIORITY 1: Correct API Structure - data.pricing.taxAmountCent + data.tax.breakdown
            if (currentPricingData?.data?.pricing?.taxAmountCent && currentPricingData?.data?.tax?.breakdown) {
                const germanTaxAmounts = currentPricingData.data.pricing.taxAmountCent; // {regular: 208, reduced: 56, noCharge: 0}
                const detailedTaxBreakdown = currentPricingData.data.tax.breakdown; // {"7": {...}, "19": {...}}
                console.log("🧾 [TAX DEBUG] *** USING CORRECT API TAX STRUCTURE ***", {
                    germanTaxAmounts,
                    detailedTaxBreakdown,
                    reduced: germanTaxAmounts.reduced,
                    regular: germanTaxAmounts.regular,
                    noCharge: germanTaxAmounts.noCharge
                });
                // Convert to display format using detailed breakdown for accuracy
                const newBreakdown = {};
                // Use detailed breakdown for precise tax rates and amounts
                Object.entries(detailedTaxBreakdown).forEach(([rateStr, data]) => {
                    const taxRate = parseFloat(rateStr);
                    const displayRate = taxRate === 7 ? '7%' : taxRate === 19 ? '19%' : `${taxRate}%`;
                    newBreakdown[displayRate] = {
                        taxAmount: data.taxAmountCent / 100,
                        taxAmountCent: data.taxAmountCent,
                        netAmount: data.netAmountCent / 100,
                        grossAmount: data.grossAmountCent / 100,
                        taxRate: data.taxRate
                    };
                });
                const totalTaxCent = (germanTaxAmounts.regular || 0) + (germanTaxAmounts.reduced || 0) + (germanTaxAmounts.noCharge || 0);
                const newCalculation = {
                    totalTax: totalTaxCent / 100,
                    totalTaxCent: totalTaxCent,
                    serviceType: currentPricingData.data.tax.serviceType || 'takeaway',
                    germanBreakdown: germanTaxAmounts,
                    detailedBreakdown: detailedTaxBreakdown
                };
                localTaxBreakdown.value = { ...newBreakdown };
                localTaxCalculation.value = { ...newCalculation };
                console.log("🧾 [TAX DEBUG] *** ✅ INITIALIZED CORRECT API TAX STRUCTURE ***", {
                    newBreakdown,
                    newCalculation,
                    source: 'correct_api_structure',
                    updatedLocalBreakdown: localTaxBreakdown.value,
                    updatedLocalCalculation: localTaxCalculation.value
                });
                return true;
            }
            // ✅ FALLBACK: Legacy tax structure
            if (currentPricingData?.data?.tax?.totalCent && currentPricingData.data.tax.totalCent > 0) {
                console.warn("🧾 [TAX DEBUG] ⚠️ Using legacy tax structure - should migrate to German structure");
                const taxAmountEuro = currentPricingData.data.tax.totalCent / 100;
                const newBreakdown = {
                    '7%': {
                        taxAmount: taxAmountEuro,
                        taxAmountCent: currentPricingData.data.tax.totalCent
                    }
                };
                const newCalculation = {
                    totalTax: taxAmountEuro,
                    totalTaxCent: currentPricingData.data.tax.totalCent,
                    serviceType: currentPricingData.data.tax.serviceType || 'takeaway'
                };
                localTaxBreakdown.value = { ...newBreakdown };
                localTaxCalculation.value = { ...newCalculation };
                console.log("🧾 [TAX DEBUG] *** ✅ INITIALIZED LEGACY TAX STRUCTURE ***", {
                    taxAmountEuro,
                    breakdown: newBreakdown,
                    calculation: newCalculation,
                    source: 'legacy_fallback',
                    updatedLocalBreakdown: localTaxBreakdown.value,
                    updatedLocalCalculation: localTaxCalculation.value
                });
                return true;
            }
            console.log("🧾 [TAX DEBUG] ❌ No tax data found in current API response");
            return false;
        };
        // Watch for incoming tax data and maintain local copies
        watch(() => props.taxBreakdown, (newTaxBreakdown) => {
            console.log("🧾 [TAX DEBUG] OrderOverview: Props taxBreakdown changed:", {
                newValue: newTaxBreakdown,
                hasKeys: !!(newTaxBreakdown && Object.keys(newTaxBreakdown).length > 0),
                keys: newTaxBreakdown ? Object.keys(newTaxBreakdown) : [],
                isEmpty: !newTaxBreakdown || Object.keys(newTaxBreakdown).length === 0,
                currentLocal: localTaxBreakdown.value,
                propsSource: 'CheckoutPage.vue'
            });
            if (newTaxBreakdown && Object.keys(newTaxBreakdown).length > 0) {
                localTaxBreakdown.value = { ...newTaxBreakdown };
                console.log("🧾 [TAX DEBUG] ✅ OrderOverview: Updated local tax breakdown from PROPS:", localTaxBreakdown.value);
            }
            else {
                console.warn("🧾 [TAX DEBUG] ❌ OrderOverview: Empty or undefined taxBreakdown from props!");
            }
        }, { immediate: true, deep: true });
        watch(() => props.taxCalculation, (newTaxCalculation) => {
            console.log("🧾 [TAX DEBUG] OrderOverview: Props taxCalculation changed:", {
                newValue: newTaxCalculation,
                hasValue: !!newTaxCalculation,
                isUndefined: newTaxCalculation === undefined,
                isNull: newTaxCalculation === null,
                currentLocal: localTaxCalculation.value,
                propsSource: 'CheckoutPage.vue'
            });
            if (newTaxCalculation) {
                localTaxCalculation.value = { ...newTaxCalculation };
                console.log("🧾 [TAX DEBUG] ✅ OrderOverview: Updated local tax calculation from PROPS:", localTaxCalculation.value);
            }
            else {
                console.warn("🧾 [TAX DEBUG] ❌ OrderOverview: Undefined/null taxCalculation from props!");
            }
        }, { immediate: true, deep: true });
        // Watch shared pricing data directly as fallback
        watch([() => orderPricing.taxBreakdown.value, () => orderPricing.taxCalculation.value], ([sharedBreakdown, sharedCalculation]) => {
            console.log("🧾 [TAX DEBUG] OrderOverview: Shared pricing data changed:", {
                sharedBreakdown,
                sharedCalculation,
                hasSharedBreakdown: !!(sharedBreakdown && Object.keys(sharedBreakdown).length > 0),
                hasSharedCalculation: !!sharedCalculation,
                sharedRawBreakdown: orderPricing.pricingData.value?.data?.pricing?.taxBreakdown,
                sharedRawCalculation: orderPricing.pricingData.value?.data?.pricing?.taxCalculation,
                currentLocalBreakdown: localTaxBreakdown.value,
                currentLocalCalculation: localTaxCalculation.value,
                shouldUseSharedBreakdown: !localTaxBreakdown.value || Object.keys(localTaxBreakdown.value).length === 0,
                shouldUseSharedCalculation: !localTaxCalculation.value
            });
            // Use shared data if props are empty but shared data exists
            if ((!localTaxBreakdown.value || Object.keys(localTaxBreakdown.value).length === 0) &&
                sharedBreakdown &&
                Object.keys(sharedBreakdown).length > 0) {
                localTaxBreakdown.value = { ...sharedBreakdown };
                console.log("🧾 [TAX DEBUG] ✅ OrderOverview: Using shared breakdown data as fallback:", {
                    sharedData: sharedBreakdown,
                    updatedLocal: localTaxBreakdown.value
                });
            }
            if (!localTaxCalculation.value && sharedCalculation) {
                localTaxCalculation.value = { ...sharedCalculation };
                console.log("🧾 [TAX DEBUG] ✅ OrderOverview: Using shared calculation data as fallback:", {
                    sharedData: sharedCalculation,
                    updatedLocal: localTaxCalculation.value
                });
            }
        }, { immediate: true, deep: true });
        // Additional watch on raw pricing data to catch all updates
        watch(() => orderPricing.pricingData.value, (pricingData) => {
            console.log("🧾 [TAX DEBUG] OrderOverview: Raw pricing data changed:", {
                hasPricingData: !!pricingData,
                hasDataObject: !!pricingData?.data,
                hasPricingObject: !!pricingData?.data?.pricing,
                hasNewTaxStructure: !!pricingData?.data?.tax,
                newTaxAmount: pricingData?.data?.tax?.totalCent,
                legacyStructure: !!pricingData?.data?.pricing,
                FULL_PRICING_DATA: pricingData?.data,
                NEW_TAX_BREAKDOWN: pricingData?.data?.tax?.breakdown,
                RAW_API_RESPONSE: pricingData
            });
            // ✅ CORRECT API STRUCTURE: Use data.pricing.taxAmountCent (German structure) + data.tax.breakdown (detailed)
            if (pricingData?.data?.pricing?.taxAmountCent && pricingData?.data?.tax?.breakdown) {
                const germanTaxAmounts = pricingData.data.pricing.taxAmountCent; // {regular: 208, reduced: 56, noCharge: 0}
                const detailedTaxBreakdown = pricingData.data.tax.breakdown; // {"7": {...}, "19": {...}}
                console.log("🧾 [TAX DEBUG] *** FOUND CORRECT API TAX STRUCTURE ***", {
                    germanTaxAmounts,
                    detailedTaxBreakdown,
                    hasRegular: 'regular' in germanTaxAmounts,
                    hasReduced: 'reduced' in germanTaxAmounts,
                    hasNoCharge: 'noCharge' in germanTaxAmounts,
                    regularAmount: germanTaxAmounts.regular,
                    reducedAmount: germanTaxAmounts.reduced,
                    noChargeAmount: germanTaxAmounts.noCharge
                });
                // Convert to display format using detailed breakdown for accuracy
                const newBreakdown = {};
                // Use detailed breakdown for precise tax rates and amounts
                Object.entries(detailedTaxBreakdown).forEach(([rateStr, data]) => {
                    const taxRate = parseFloat(rateStr);
                    const displayRate = taxRate === 7 ? '7%' : taxRate === 19 ? '19%' : `${taxRate}%`;
                    newBreakdown[displayRate] = {
                        taxAmount: data.taxAmountCent / 100,
                        taxAmountCent: data.taxAmountCent,
                        netAmount: data.netAmountCent / 100,
                        grossAmount: data.grossAmountCent / 100,
                        taxRate: data.taxRate
                    };
                });
                const totalTaxCent = (germanTaxAmounts.regular || 0) + (germanTaxAmounts.reduced || 0) + (germanTaxAmounts.noCharge || 0);
                const newCalculation = {
                    totalTax: totalTaxCent / 100,
                    totalTaxCent: totalTaxCent,
                    serviceType: pricingData.data.tax.serviceType || 'takeaway',
                    germanBreakdown: germanTaxAmounts,
                    detailedBreakdown: detailedTaxBreakdown
                };
                localTaxBreakdown.value = newBreakdown;
                localTaxCalculation.value = newCalculation;
                console.log("🧾 [TAX DEBUG] *** ✅ UPDATED TO CORRECT API TAX STRUCTURE ***", {
                    newBreakdown,
                    newCalculation,
                    source: 'correct_api_structure'
                });
                return; // Skip legacy processing
            }
            if (pricingData?.data?.pricing) {
                const rawBreakdown = pricingData.data.pricing.taxBreakdown;
                const rawCalculation = pricingData.data.pricing.taxCalculation;
                console.log("🧾 [TAX DEBUG] OrderOverview: Legacy pricing structure found:", {
                    hasRawBreakdown: !!(rawBreakdown && Object.keys(rawBreakdown).length > 0),
                    hasRawCalculation: !!rawCalculation,
                    rawBreakdown,
                    rawCalculation,
                    currentLocalBreakdown: localTaxBreakdown.value,
                    currentLocalCalculation: localTaxCalculation.value,
                    shouldUseLegacyBreakdown: !localTaxBreakdown.value || Object.keys(localTaxBreakdown.value).length === 0
                });
                // Force update local data from raw pricing data
                if (rawBreakdown &&
                    Object.keys(rawBreakdown).length > 0 &&
                    (!localTaxBreakdown.value || Object.keys(localTaxBreakdown.value).length === 0)) {
                    localTaxBreakdown.value = { ...rawBreakdown };
                    console.log("🧾 [TAX DEBUG] ✅ OrderOverview: Using raw breakdown data as emergency fallback:", {
                        rawData: rawBreakdown,
                        updatedLocal: localTaxBreakdown.value
                    });
                }
                if (rawCalculation && !localTaxCalculation.value) {
                    localTaxCalculation.value = { ...rawCalculation };
                    console.log("🧾 [TAX DEBUG] ✅ OrderOverview: Using raw calculation data as emergency fallback:", {
                        rawData: rawCalculation,
                        updatedLocal: localTaxCalculation.value
                    });
                }
            }
        }, { immediate: true, deep: true });
        // ✅ IMMEDIATE MOUNT: Force API data loading and initialize on component mount
        onMounted(async () => {
            console.log("🧾 [TAX DEBUG] ======= OrderOverview: Component mounted =======");
            console.log("🧾 [TAX DEBUG] Initial state:", {
                propsItems: props.items.length,
                propsSubtotal: props.subtotal,
                propsOrderType: props.orderType,
                propsTaxBreakdown: props.taxBreakdown,
                propsTaxCalculation: props.taxCalculation,
                cartStoreItems: cartStore.items.length,
                cartDeliveryType: cartStore.deliveryType,
                hasPricingData: !!orderPricing.pricingData.value,
                currentLocalBreakdown: localTaxBreakdown.value,
                currentLocalCalculation: localTaxCalculation.value
            });
            // Try to initialize from existing API data first
            const initialized = initializeTaxDataFromApi();
            if (!initialized) {
                console.log("🧾 [TAX DEBUG] No existing API data found - forcing pricing calculation");
                // ✅ FORCE API CALL: If no pricing data exists, trigger calculation
                const itemsToCalculate = props.items.length > 0 ? props.items : cartStore.items;
                const orderTypeToUse = props.orderType || cartStore.deliveryType || 'pickup';
                console.log("🧾 [TAX DEBUG] API calculation parameters:", {
                    itemsToCalculate: itemsToCalculate.length,
                    orderTypeToUse,
                    hasPricingData: !!orderPricing.pricingData.value,
                    shouldCalculate: itemsToCalculate.length > 0 && !orderPricing.pricingData.value
                });
                if (itemsToCalculate.length > 0 && !orderPricing.pricingData.value) {
                    console.log("🧾 [TAX DEBUG] 🚀 Starting pricing calculation for", itemsToCalculate.length, "items");
                    try {
                        // ✅ CRITICAL: Format deliveryAddress as string for delivery orders
                        let deliveryAddr = undefined;
                        if (orderTypeToUse === 'delivery') {
                            const { street, city, postalCode } = cartStore.deliveryAddress;
                            if (street?.trim() && city?.trim() && postalCode?.trim()) {
                                deliveryAddr = `${street.trim()}, ${postalCode.trim()} ${city.trim()}`;
                            }
                        }
                        await orderPricing.calculateOrderPricing(itemsToCalculate, orderTypeToUse, deliveryAddr);
                        console.log("🧾 [TAX DEBUG] *** ✅ FORCED API CALCULATION COMPLETED ***");
                        // After API call, try to initialize again
                        const nowInitialized = initializeTaxDataFromApi();
                        if (nowInitialized) {
                            console.log("🧾 [TAX DEBUG] *** ✅ TAX DATA INITIALIZED AFTER FORCED API CALL ***");
                        }
                        else {
                            console.warn("🧾 [TAX DEBUG] *** ❌ STILL NO TAX DATA AFTER API CALL ***");
                        }
                        // Update minimum order state after API call
                        updateMinimumOrderError();
                    }
                    catch (error) {
                        console.error("🧾 [TAX DEBUG] ❌ Failed to force pricing calculation:", error);
                    }
                }
                else {
                    console.log("🧾 [TAX DEBUG] Skipping API call:", {
                        reason: itemsToCalculate.length === 0 ? 'No items' : 'Pricing data exists'
                    });
                }
            }
            else {
                console.log("🧾 [TAX DEBUG] ✅ Found existing tax data on mount");
                updateMinimumOrderError();
            }
            // ✅ EVENT LISTENER: Listen for global orderPricingChanged events
            const handlePricingChange = (event) => {
                if (event.detail.projectId === 'daluigi') {
                    // Update tax data if available - use correct API structure
                    if (event.detail.pricingData?.data?.pricing?.taxAmountCent && event.detail.pricingData?.data?.tax?.breakdown) {
                        const germanTaxAmounts = event.detail.pricingData.data.pricing.taxAmountCent; // {regular: 208, reduced: 56, noCharge: 0}
                        const detailedTaxBreakdown = event.detail.pricingData.data.tax.breakdown; // {"7": {...}, "19": {...}}
                        console.log("🧾 [TAX DEBUG] *** EVENT: Found Correct API Tax Structure ***", {
                            germanTaxAmounts,
                            detailedTaxBreakdown
                        });
                        // Convert to display format using detailed breakdown for accuracy
                        const newBreakdown = {};
                        // Use detailed breakdown for precise tax rates and amounts
                        Object.entries(detailedTaxBreakdown).forEach(([rateStr, data]) => {
                            const taxRate = parseFloat(rateStr);
                            const displayRate = taxRate === 7 ? '7%' : taxRate === 19 ? '19%' : `${taxRate}%`;
                            newBreakdown[displayRate] = {
                                taxAmount: data.taxAmountCent / 100,
                                taxAmountCent: data.taxAmountCent,
                                netAmount: data.netAmountCent / 100,
                                grossAmount: data.grossAmountCent / 100,
                                taxRate: data.taxRate
                            };
                        });
                        const totalTaxCent = (germanTaxAmounts.regular || 0) + (germanTaxAmounts.reduced || 0) + (germanTaxAmounts.noCharge || 0);
                        const newCalculation = {
                            totalTax: totalTaxCent / 100,
                            totalTaxCent: totalTaxCent,
                            serviceType: event.detail.pricingData.data.tax.serviceType || 'takeaway',
                            germanBreakdown: germanTaxAmounts,
                            detailedBreakdown: detailedTaxBreakdown
                        };
                        localTaxBreakdown.value = { ...newBreakdown };
                        localTaxCalculation.value = { ...newCalculation };
                        console.log("🧾 [TAX DEBUG] *** ✅ UPDATED CORRECT API TAX DATA FROM EVENT ***", {
                            newBreakdown,
                            newCalculation,
                            source: 'event_correct_api'
                        });
                    }
                    // Fallback to legacy tax structure
                    else if (event.detail.pricingData?.data?.tax?.totalCent) {
                        console.warn("🧾 [TAX DEBUG] ⚠️ EVENT: Using legacy tax structure");
                        const taxData = event.detail.pricingData.data.tax;
                        const taxAmountEuro = taxData.totalCent / 100;
                        const newBreakdown = {
                            '7%': {
                                taxAmount: taxAmountEuro,
                                taxAmountCent: taxData.totalCent
                            }
                        };
                        const newCalculation = {
                            totalTax: taxAmountEuro,
                            totalTaxCent: taxData.totalCent,
                            serviceType: taxData.serviceType || 'takeaway'
                        };
                        localTaxBreakdown.value = { ...newBreakdown };
                        localTaxCalculation.value = { ...newCalculation };
                        console.log("🧾 [TAX DEBUG] *** ✅ UPDATED LEGACY TAX DATA FROM EVENT ***");
                    }
                    // Update minimum order state  
                    updateMinimumOrderError();
                }
            };
            window.addEventListener('orderPricingChanged', handlePricingChange);
            // ✅ EVENT LISTENER: Listen for minimum order events
            const handleMinimumOrderChange = (event) => {
                if (event.detail.projectId === 'daluigi') {
                    console.log("🧾 OrderOverview: Received minimumOrderNotReached event", event.detail);
                    updateMinimumOrderError();
                }
            };
            window.addEventListener('minimumOrderNotReached', handleMinimumOrderChange);
            // Cleanup on unmount
            onUnmounted(() => {
                window.removeEventListener('orderPricingChanged', handlePricingChange);
                window.removeEventListener('minimumOrderNotReached', handleMinimumOrderChange);
            });
        });
        // ✅ CART REACTIVITY: Watch cart items and trigger pricing updates
        watch(() => props.items.length, async (newLength, oldLength) => {
            if (newLength !== oldLength) {
                console.log("🧾 OrderOverview: Cart items changed - forcing pricing recalculation", {
                    newLength,
                    oldLength,
                    hasItems: newLength > 0
                });
                // Clear local tax data to force refresh from API
                if (newLength === 0) {
                    localTaxBreakdown.value = {};
                    localTaxCalculation.value = null;
                }
                // ✅ UPDATE: Minimum order state when cart changes
                updateMinimumOrderError();
            }
        }, { immediate: true });
        // ✅ MINIMUM ORDER REACTIVITY: Watch for subtotal changes (affects minimum order validation)
        watch(displaySubtotal, async (newSubtotal, oldSubtotal) => {
            if (newSubtotal !== oldSubtotal) {
                // Force API recalculation when subtotal changes to get fresh minimum order data
                const itemsToRecalculate = props.items.length > 0 ? props.items : cartStore.items;
                if (itemsToRecalculate.length > 0) {
                    try {
                        // ✅ CRITICAL: Format deliveryAddress as string for delivery orders
                        let deliveryAddr = undefined;
                        if (props.orderType === 'delivery') {
                            const { street, city, postalCode } = cartStore.deliveryAddress;
                            if (street?.trim() && city?.trim() && postalCode?.trim()) {
                                deliveryAddr = `${street.trim()}, ${postalCode.trim()} ${city.trim()}`;
                            }
                        }
                        await orderPricing.calculateOrderPricing(itemsToRecalculate, props.orderType, deliveryAddr);
                    }
                    catch (error) {
                        console.error("API recalculation failed:", error);
                    }
                }
                // Update minimum order state after API recalculation
                updateMinimumOrderError();
            }
        }, { immediate: true });
        // ✅ ORDER TYPE REACTIVITY: Watch for order type changes (pickup vs delivery affects minimum order)
        watch(() => props.orderType, async (newOrderType, oldOrderType) => {
            if (newOrderType !== oldOrderType) {
                console.log("🧾 [DEBUG] OrderOverview: Order type changed", {
                    newOrderType,
                    oldOrderType,
                    needsApiRecalculation: true
                });
                // ✅ FORCE API RECALCULATION: Order type change requires fresh API call for correct minimum order values
                const itemsToRecalculate = props.items.length > 0 ? props.items : cartStore.items;
                if (itemsToRecalculate.length > 0) {
                    try {
                        // ✅ CRITICAL: Format deliveryAddress as string for delivery orders
                        let deliveryAddr = undefined;
                        if (newOrderType === 'delivery') {
                            const { street, city, postalCode } = cartStore.deliveryAddress;
                            if (street?.trim() && city?.trim() && postalCode?.trim()) {
                                deliveryAddr = `${street.trim()}, ${postalCode.trim()} ${city.trim()}`;
                            }
                        }
                        await orderPricing.calculateOrderPricing(itemsToRecalculate, newOrderType, deliveryAddr);
                    }
                    catch (error) {
                        console.error("API recalculation failed:", error);
                    }
                }
                // Update minimum order state after API recalculation
                updateMinimumOrderError();
            }
        }, { immediate: true });
        // ✅ ENHANCED WATCHER: React to API data changes including first load (for page reload scenarios)
        watch(() => orderPricing.pricingData.value, (pricingData, oldPricingData) => {
            // Trigger on first data arrival (null -> data) or data changes
            const isFirstLoad = !oldPricingData && pricingData;
            console.log("🧾 OrderOverview: pricingData changed", { isFirstLoad, hasNewData: !!pricingData });
            // Process both first load and subsequent changes
            console.log("🧾 OrderOverview: PROJECT pricing data changed:", {
                hasNewTax: !!(pricingData?.data?.tax?.totalCent),
                hasLegacyPricing: !!(pricingData?.data?.pricing),
                newTaxAmount: pricingData?.data?.tax?.totalCent || 0,
                projectStateExists: !!orderPricing.pricingData.value,
            });
            // ✅ NEW API Structure: Handle tax data from enhanced API response
            if (pricingData?.data?.tax?.totalCent && pricingData.data.tax.totalCent > 0) {
                const taxAmountEuro = pricingData.data.tax.totalCent / 100;
                const newBreakdown = {
                    '7%': {
                        taxAmount: taxAmountEuro,
                        taxAmountCent: pricingData.data.tax.totalCent
                    }
                };
                const newCalculation = {
                    totalTax: taxAmountEuro,
                    totalTaxCent: pricingData.data.tax.totalCent,
                    serviceType: pricingData.data.tax.serviceType || 'takeaway'
                };
                localTaxBreakdown.value = { ...newBreakdown };
                localTaxCalculation.value = { ...newCalculation };
                console.log("🧾 OrderOverview: *** USING NEW API TAX DATA ***", {
                    breakdown: newBreakdown,
                    calculation: newCalculation
                });
            }
            // Legacy API Structure fallback
            else if (pricingData?.data?.pricing) {
                const breakdown = pricingData.data.pricing.taxBreakdown;
                const calculation = pricingData.data.pricing.taxCalculation;
                console.log("🧾 OrderOverview: Using legacy pricing structure:", {
                    hasBreakdown: !!(breakdown && Object.keys(breakdown).length > 0),
                    hasCalculation: !!calculation,
                    breakdown,
                    calculation,
                });
                // Force update local data from project pricing data as ULTIMATE FALLBACK
                if (breakdown && Object.keys(breakdown).length > 0) {
                    localTaxBreakdown.value = { ...breakdown };
                    console.log("🧾 OrderOverview: *** USING LEGACY BREAKDOWN DATA AS FALLBACK ***");
                }
                if (calculation) {
                    localTaxCalculation.value = { ...calculation };
                    console.log("🧾 OrderOverview: *** USING LEGACY CALCULATION DATA AS FALLBACK ***");
                }
            }
        }, { immediate: true, deep: true });
        // Display tax data - now uses reactive local data updated by watcher
        const displayTaxBreakdown = computed(() => {
            // Priority: local data (updated by watcher) > props > shared > API direct access
            const localHasData = Object.keys(localTaxBreakdown.value).length > 0;
            const propsHasData = props.taxBreakdown && Object.keys(props.taxBreakdown).length > 0;
            const sharedHasData = orderPricing.taxBreakdown.value && Object.keys(orderPricing.taxBreakdown.value).length > 0;
            const finalBreakdown = localHasData
                ? localTaxBreakdown.value
                : propsHasData
                    ? props.taxBreakdown
                    : sharedHasData
                        ? orderPricing.taxBreakdown.value
                        : {};
            console.log("🧾 [TAX DEBUG] displayTaxBreakdown computed:", {
                localHasData,
                propsHasData,
                sharedHasData,
                selectedSource: localHasData ? 'local' : propsHasData ? 'props' : sharedHasData ? 'shared' : 'empty',
                localData: localTaxBreakdown.value,
                propsData: props.taxBreakdown,
                sharedData: orderPricing.taxBreakdown.value,
                finalBreakdown,
                finalHasKeys: Object.keys(finalBreakdown).length > 0
            });
            return finalBreakdown;
        });
        const displayTaxCalculation = computed(() => {
            // Priority: local data (updated by watcher) > props > shared
            const hasLocal = !!localTaxCalculation.value;
            const hasProps = !!props.taxCalculation;
            const hasShared = !!orderPricing.taxCalculation.value;
            const finalCalculation = localTaxCalculation.value ||
                props.taxCalculation ||
                orderPricing.taxCalculation.value ||
                null;
            console.log("🧾 [TAX DEBUG] displayTaxCalculation computed:", {
                hasLocal,
                hasProps,
                hasShared,
                selectedSource: hasLocal ? 'local' : hasProps ? 'props' : hasShared ? 'shared' : 'null',
                localData: localTaxCalculation.value,
                propsData: props.taxCalculation,
                sharedData: orderPricing.taxCalculation.value,
                finalCalculation
            });
            return finalCalculation;
        });
        // ✅ DEPOSIT: Gesamtpfand berechnen aus Cart Items (reaktiv)
        const totalDeposit = computed(() => {
            return props.items.reduce((sum, item) => {
                const deposit = item.deposit;
                if (deposit && deposit.type !== 'none' && deposit.amountCent > 0) {
                    return sum + (deposit.amountCent / 100) * item.quantity;
                }
                return sum;
            }, 0);
        });
        // IMMEDIATE CHECK on mount for global data
        onMounted(async () => {
            console.log("🧾 OrderOverview MOUNTED - Props received:", {
                itemCount: props.items.length,
                subtotal: props.subtotal,
                deliveryFee: props.deliveryFee,
                serviceFee: props.serviceFee,
                totalAmount: props.totalAmount,
                orderType: props.orderType
            });
            // Update minimum order error based on current props
            updateMinimumOrderError();
            console.log("� OrderOverview MOUNTED - Current state:", {
                orderStatusMessage: orderStatusMessage.value,
                minimumOrderInfo: minimumOrderInfo.value,
                isMinimumOrderError: isMinimumOrderError.value,
                pricingDataExists: !!orderPricing.pricingData.value
            });
            // Function to check and copy global data
            const checkAndCopyProjectData = () => {
                if (orderPricing.pricingData.value?.data?.pricing) {
                    const breakdown = orderPricing.pricingData.value.data.pricing.taxBreakdown;
                    const calculation = orderPricing.pricingData.value.data.pricing.taxCalculation;
                    console.log("🧾 OrderOverview - FOUND PROJECT DATA:", {
                        hasProjectState: !!orderPricing.pricingData.value,
                        breakdown,
                        calculation,
                        hasBreakdown: !!(breakdown && Object.keys(breakdown).length > 0),
                        hasCalculation: !!calculation,
                    });
                    // Immediately copy project data if it exists
                    if (breakdown && Object.keys(breakdown).length > 0) {
                        localTaxBreakdown.value = { ...breakdown };
                        console.log("🧾 OrderOverview: *** COPIED PROJECT BREAKDOWN ***");
                        return true;
                    }
                    if (calculation) {
                        localTaxCalculation.value = { ...calculation };
                        console.log("🧾 OrderOverview: *** COPIED PROJECT CALCULATION ***");
                        return true;
                    }
                }
                return false;
            };
            // Check immediately
            let foundData = checkAndCopyProjectData();
            if (!foundData) {
                console.log("🧾 OrderOverview onMounted - NO PROJECT DATA YET, waiting...");
                // Wait a bit and try again (for async data)
                await nextTick();
                foundData = checkAndCopyProjectData();
                if (!foundData) {
                    // Try one more time after a small delay
                    setTimeout(() => {
                        checkAndCopyProjectData();
                    }, 100);
                    // Test periodically for minimum order data
                    const intervalId = setInterval(() => {
                        console.log("🧾 OrderOverview - Periodic check:", {
                            orderStatusMessage: orderStatusMessage.value,
                            minimumOrderInfo: minimumOrderInfo.value,
                            pricingCode: orderPricing.pricingData.value?.code,
                            hasPricingData: !!orderPricing.pricingData.value,
                        });
                        if (orderPricing.pricingData.value?.code === "MINIMUM_ORDER_NOT_REACHED") {
                            console.log("🧾 OrderOverview - Found minimum order data! Clearing interval");
                            clearInterval(intervalId);
                        }
                    }, 500); // Check every 500ms
                    // Clear interval after 5 seconds to avoid infinite checking
                    setTimeout(() => {
                        clearInterval(intervalId);
                        console.log("🧾 OrderOverview - Stopped periodic checking after 5 seconds");
                    }, 5000);
                }
            }
        });
        // Calculate total price including extras for a single item
        const getItemTotalPrice = (item) => {
            // ✅ PRECISION FIX: Use server-calculated totalPrice when available
            if (item.totalPrice !== undefined && item.totalPrice !== null) {
                return item.totalPrice / item.quantity;
            }
            // Fallback to legacy calculation for compatibility
            // ✅ FIX: Use cent-based pricing with proper size modifier logic
            let totalPriceCent = item.menuItem.priceCent || (item.menuItem.price * 100);
            // ✅ Add size modifier if present (not absolute price!)
            if (item.selectedSize && item.selectedSize.priceModifierCent !== undefined) {
                const sizeModifierCent = item.selectedSize.priceModifierCent || 0;
                totalPriceCent += sizeModifierCent;
            }
            // Add extras prices (convert to cent if needed)
            if (item.extras && item.extras.length > 0) {
                const extrasTotalCent = item.extras.reduce((sum, extra) => {
                    const extraPriceCent = extra.priceCent || (extra.price * 100);
                    return sum + (extraPriceCent || 0);
                }, 0);
                totalPriceCent += extrasTotalCent;
            }
            // Return in Euro for formatPrice compatibility
            return totalPriceCent / 100;
        };
        const failedImages = ref(new Set());
        // Use props to avoid lint error - with fallback formatPrice
        const { items } = props;
        // ✅ SAFE formatPrice: Use props.formatPrice or fallback to orderPricing.formatPrice or simple formatting
        const formatPrice = (price) => {
            // Try props.formatPrice first
            if (props.formatPrice && typeof props.formatPrice === 'function') {
                try {
                    return props.formatPrice(price);
                }
                catch (error) {
                    console.warn('🧾 OrderOverview: props.formatPrice failed, using fallback:', error);
                }
            }
            // Try orderPricing.formatPrice as fallback
            if (orderPricing.formatPrice && typeof orderPricing.formatPrice === 'function') {
                try {
                    return orderPricing.formatPrice(price);
                }
                catch (error) {
                    console.warn('🧾 OrderOverview: orderPricing.formatPrice failed, using basic formatting:', error);
                }
            }
            // Basic fallback formatting
            return new Intl.NumberFormat('de-DE', {
                style: 'currency',
                currency: 'EUR',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(price);
        };
        // Image handling
        function getImageSrc(originalSrc) {
            if (!originalSrc || failedImages.value.has(originalSrc)) {
                return defaultFoodImage;
            }
            return originalSrc;
        }
        function handleImageError(event, _configId) {
            const img = event.target;
            if (img.src && img.src !== defaultFoodImage) {
                failedImages.value.add(img.src);
                img.src = defaultFoodImage;
                img.onerror = null; // Prevent infinite loop if default image also fails
            }
        }
        function updateQuantity(configId, quantity) {
            emit("updateQuantity", configId, quantity);
        }
        function removeItem(configId) {
            emit("removeItem", configId);
        }
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "text-xl font-bold text-gray-800" }, "Bestellübersicht", -1 /* CACHED */)),
                    _createVNode(_component_router_link, {
                        to: "/menu",
                        class: "flex items-center gap-2 px-3 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors"
                    }, {
                        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                                _createElementVNode("i", { class: "fas fa-arrow-left" }, null, -1 /* CACHED */),
                                _createElementVNode("span", { class: "hidden sm:inline" }, "Zur Speisekarte", -1 /* CACHED */)
                            ]))]),
                        _: 1 /* STABLE */
                    })
                ]),
                _createElementVNode("div", _hoisted_3, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items), (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                            key: item.configId,
                            class: "bg-white border border-gray-200 rounded-xl p-4 shadow-sm"
                        }, [
                            (item.itemType === 'menu')
                                ? (_openBlock(), _createBlock(CartMenuLine, {
                                    key: 0,
                                    item: item
                                }, null, 8 /* PROPS */, ["item"]))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createCommentVNode(" Item Info "),
                                    _createElementVNode("div", _hoisted_4, [
                                        _createCommentVNode(" Item Image "),
                                        _createElementVNode("div", _hoisted_5, [
                                            _createElementVNode("img", {
                                                src: getImageSrc(item.menuItem.imageUrl || ''),
                                                alt: item.menuItem.name,
                                                class: "w-16 h-16 object-cover rounded-lg",
                                                onError: (e) => handleImageError(e, item.configId)
                                            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_6)
                                        ]),
                                        _createCommentVNode(" Item Details "),
                                        _createElementVNode("div", _hoisted_7, [
                                            _createElementVNode("h4", _hoisted_8, _toDisplayString(item.menuItem.name), 1 /* TEXT */),
                                            (item.selectedSize)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(item.selectedSize.name), 1 /* TEXT */))
                                                : _createCommentVNode("v-if", true),
                                            _createCommentVNode(" Extras and Modifications "),
                                            (item.extras?.length ||
                                                item.removedIngredients?.length ||
                                                item.specialInstructions ||
                                                item.selectedMandatoryIngredients?.length)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                                    _createCommentVNode(" Mandatory Ingredients (selected options) - flat display without group labels "),
                                                    (item.selectedMandatoryIngredients?.length)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                                            _createElementVNode("div", _hoisted_12, [
                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.selectedMandatoryIngredients, (group) => {
                                                                    return (_openBlock(), _createElementBlock(_Fragment, {
                                                                        key: group.groupName
                                                                    }, [
                                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.selectedIngredients, (ingredient) => {
                                                                            return (_openBlock(), _createElementBlock("span", {
                                                                                key: ingredient.ingredientId,
                                                                                class: "bg-blue-100 text-blue-800 px-2 py-1 rounded text-xs font-medium"
                                                                            }, " mit " + _toDisplayString(ingredient.name), 1 /* TEXT */));
                                                                        }), 128 /* KEYED_FRAGMENT */))
                                                                    ], 64 /* STABLE_FRAGMENT */));
                                                                }), 128 /* KEYED_FRAGMENT */))
                                                            ])
                                                        ]))
                                                        : _createCommentVNode("v-if", true),
                                                    _createCommentVNode(" Extra ingredients "),
                                                    (item.extras?.length)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                                            _createElementVNode("div", _hoisted_14, [
                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.extras, (extra) => {
                                                                    return (_openBlock(), _createElementBlock("span", {
                                                                        key: extra.id,
                                                                        class: "bg-green-100 text-green-800 px-2 py-1 rounded text-xs font-medium"
                                                                    }, " + " + _toDisplayString(extra.name) + " (" + _toDisplayString(formatPrice(extra.price)) + ") ", 1 /* TEXT */));
                                                                }), 128 /* KEYED_FRAGMENT */))
                                                            ])
                                                        ]))
                                                        : _createCommentVNode("v-if", true),
                                                    _createCommentVNode(" Removed ingredients "),
                                                    (item.removedIngredients?.length)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                                            _createElementVNode("div", _hoisted_16, [
                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.removedIngredients, (ingredient) => {
                                                                    return (_openBlock(), _createElementBlock("span", {
                                                                        key: typeof ingredient === 'string' ? ingredient : ingredient.id,
                                                                        class: "px-2 py-1 rounded text-xs font-medium",
                                                                        style: _normalizeStyle({
                                                                            backgroundColor: themePrimaryColor.value + '15',
                                                                            color: themePrimaryColor.value
                                                                        })
                                                                    }, " ohne " + _toDisplayString(typeof ingredient === 'string' ? ingredient : ingredient.name), 5 /* TEXT, STYLE */));
                                                                }), 128 /* KEYED_FRAGMENT */))
                                                            ])
                                                        ]))
                                                        : _createCommentVNode("v-if", true),
                                                    _createCommentVNode(" Special instructions "),
                                                    (item.specialInstructions)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                                            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "text-xs font-medium text-gray-700 mb-1" }, "Anmerkungen:", -1 /* CACHED */)),
                                                            _createElementVNode("div", _hoisted_18, _toDisplayString(item.specialInstructions), 1 /* TEXT */)
                                                        ]))
                                                        : _createCommentVNode("v-if", true)
                                                ]))
                                                : _createCommentVNode("v-if", true)
                                        ])
                                    ])
                                ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */)),
                            _createCommentVNode(" Quantity Controls & Price - Full Width Below Product "),
                            _createElementVNode("div", _hoisted_19, [
                                _createCommentVNode(" Quantity Controls "),
                                _createElementVNode("div", _hoisted_20, [
                                    _createElementVNode("button", {
                                        onClick: ($event) => (item.quantity === 1 ? removeItem(item.configId) : updateQuantity(item.configId, item.quantity - 1)),
                                        class: "w-9 h-9 rounded-full flex items-center justify-center transition-colors duration-200 font-semibold shadow-sm",
                                        style: _normalizeStyle({
                                            backgroundColor: themePrimaryColor.value + '15',
                                            color: themePrimaryColor.value
                                        }),
                                        title: item.quantity === 1 ? 'Artikel entfernen' : 'Menge verringern',
                                        onMouseenter: _cache[0] || (_cache[0] = e => e.target.style.filter = 'brightness(0.9)'),
                                        onMouseleave: _cache[1] || (_cache[1] = e => e.target.style.filter = 'brightness(1)')
                                    }, [
                                        _createElementVNode("i", {
                                            class: _normalizeClass(item.quantity === 1
                                                ? 'fas fa-trash text-sm'
                                                : 'fas fa-minus text-sm')
                                        }, null, 2 /* CLASS */)
                                    ], 44 /* STYLE, PROPS, NEED_HYDRATION */, _hoisted_21),
                                    _createElementVNode("span", _hoisted_22, _toDisplayString(item.quantity), 1 /* TEXT */),
                                    _createElementVNode("button", {
                                        onClick: ($event) => (updateQuantity(item.configId, item.quantity + 1)),
                                        class: "w-9 h-9 bg-green-100 hover:bg-green-200 text-green-700 rounded-full flex items-center justify-center transition-colors duration-200 font-semibold shadow-sm"
                                    }, [...(_cache[5] || (_cache[5] = [
                                            _createElementVNode("i", { class: "fas fa-plus text-sm" }, null, -1 /* CACHED */)
                                        ]))], 8 /* PROPS */, _hoisted_23)
                                ]),
                                _createCommentVNode(" Price "),
                                _createElementVNode("div", _hoisted_24, [
                                    _createElementVNode("div", {
                                        class: "font-bold text-lg",
                                        style: _normalizeStyle({ color: themePrimaryColor.value })
                                    }, _toDisplayString(formatPrice(getItemTotalPrice(item) * item.quantity)), 5 /* TEXT, STYLE */),
                                    _createElementVNode("div", _hoisted_25, _toDisplayString(formatPrice(getItemTotalPrice(item))) + " / Stück ", 1 /* TEXT */),
                                    (item.menuItem.originalPrice)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, " Ersparnis: " + _toDisplayString(formatPrice((item.menuItem.originalPrice - getItemTotalPrice(item)) *
                                            item.quantity)), 1 /* TEXT */))
                                        : _createCommentVNode("v-if", true)
                                ])
                            ])
                        ]));
                    }), 128 /* KEYED_FRAGMENT */)),
                    _createCommentVNode(" Mindestbestellwert Warnung "),
                    (isMinimumOrderError.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                            _createElementVNode("div", _hoisted_28, [
                                _cache[8] || (_cache[8] = _createElementVNode("div", { class: "flex-shrink-0" }, [
                                    _createElementVNode("svg", {
                                        class: "w-5 h-5 text-amber-600 mt-0.5",
                                        fill: "none",
                                        stroke: "currentColor",
                                        viewBox: "0 0 24 24"
                                    }, [
                                        _createElementVNode("path", {
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round",
                                            "stroke-width": "2",
                                            d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                        })
                                    ])
                                ], -1 /* CACHED */)),
                                _createElementVNode("div", _hoisted_29, [
                                    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "w-full" }, [
                                        _createElementVNode("h3", { class: "text-sm font-semibold text-amber-800 mb-1" }, " Mindestbestellwert nicht erreicht ")
                                    ], -1 /* CACHED */)),
                                    (_unref(minimumOrderInfo))
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 0,
                                            class: "w-full flex text-xs bg-white p-2 rounded border",
                                            style: _normalizeStyle({ color: themePrimaryColor.value })
                                        }, [
                                            _createElementVNode("div", _hoisted_30, [
                                                _createElementVNode("div", _hoisted_31, [
                                                    _cache[6] || (_cache[6] = _createElementVNode("span", null, "Noch hinzufügen:", -1 /* CACHED */)),
                                                    _createElementVNode("span", _hoisted_32, _toDisplayString(formatPrice(_unref(minimumOrderInfo).missing)), 1 /* TEXT */)
                                                ])
                                            ])
                                        ], 4 /* STYLE */))
                                        : _createCommentVNode("v-if", true)
                                ])
                            ])
                        ]))
                        : _createCommentVNode("v-if", true),
                    _createCommentVNode(" Preisübersicht "),
                    _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("div", {
                                class: _normalizeClass(["flex justify-between text-sm text-gray-600", { 'font-semibold text-amber-700': isMinimumOrderError.value }])
                            }, [
                                _cache[9] || (_cache[9] = _createElementVNode("span", null, "Zwischensumme", -1 /* CACHED */)),
                                _createElementVNode("span", null, _toDisplayString(formatPrice(displaySubtotal.value)), 1 /* TEXT */)
                            ], 2 /* CLASS */),
                            _createCommentVNode(" ✅ NEW: Discount Display "),
                            (_ctx.discountInfo && _ctx.discountInfo.isValid)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                    _createElementVNode("div", _hoisted_36, [
                                        _cache[10] || (_cache[10] = _createElementVNode("i", { class: "fas fa-percent" }, null, -1 /* CACHED */)),
                                        _createElementVNode("span", null, "Rabatt (" + _toDisplayString(_ctx.discountInfo.code) + ")", 1 /* TEXT */)
                                    ]),
                                    _createElementVNode("span", null, "-" + _toDisplayString(formatPrice(_ctx.discountInfo.amountEuro || 0)), 1 /* TEXT */)
                                ]))
                                : _createCommentVNode("v-if", true),
                            (_ctx.orderType === 'delivery')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                    _createElementVNode("div", _hoisted_38, [
                                        _cache[11] || (_cache[11] = _createElementVNode("span", null, "Liefergebühr", -1 /* CACHED */)),
                                        (!isDeliveryFeeCalculating.value && freeDeliveryMessage.value)
                                            ? (_openBlock(), _createElementBlock("span", {
                                                key: 0,
                                                class: "text-xs font-bold mt-1",
                                                style: _normalizeStyle({ color: themePrimaryColor.value })
                                            }, _toDisplayString(freeDeliveryMessage.value), 5 /* TEXT, STYLE */))
                                            : (!isDeliveryFeeCalculating.value && displayDeliveryFee.value === 0 && freeDeliveryReason.value)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(freeDeliveryReason.value), 1 /* TEXT */))
                                                : _createCommentVNode("v-if", true)
                                    ]),
                                    (isDeliveryFeeCalculating.value)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_40, "Berechne..."))
                                        : (displayDeliveryFee.value > 0)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(_unref(checkoutStore).hasCompleteDeliveryAddress ? formatPrice(displayDeliveryFee.value) : `ab ${formatPrice(displayDeliveryFee.value)}`), 1 /* TEXT */))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_42, [...(_cache[12] || (_cache[12] = [
                                                    _createElementVNode("i", { class: "fas fa-check-circle mr-1" }, null, -1 /* CACHED */),
                                                    _createTextVNode("Kostenlos ", -1 /* CACHED */)
                                                ]))]))
                                ]))
                                : _createCommentVNode("v-if", true),
                            (displayServiceFee.value > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                    _cache[13] || (_cache[13] = _createElementVNode("span", null, "Service-Gebühr", -1 /* CACHED */)),
                                    _createElementVNode("span", null, _toDisplayString(formatPrice(displayServiceFee.value)), 1 /* TEXT */)
                                ]))
                                : _createCommentVNode("v-if", true),
                            _createCommentVNode(" ✅ DEPOSIT: Pfand-Anzeige (vor MwSt., da steuerfrei) "),
                            (totalDeposit.value > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                    _cache[14] || (_cache[14] = _createElementVNode("span", { class: "flex items-center gap-2" }, [
                                        _createElementVNode("i", { class: "fas fa-recycle text-green-600" }),
                                        _createTextVNode(" Pfand (steuerfrei) ")
                                    ], -1 /* CACHED */)),
                                    _createElementVNode("span", _hoisted_45, _toDisplayString(formatPrice(totalDeposit.value)), 1 /* TEXT */)
                                ]))
                                : _createCommentVNode("v-if", true),
                            _createCommentVNode(" MwSt-Aufschlüsselung "),
                            (displayTaxBreakdown.value && Object.keys(displayTaxBreakdown.value).length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                    _createElementVNode("div", _hoisted_47, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(displayTaxBreakdown.value), ([taxRate, data]) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                                key: taxRate,
                                                class: "flex justify-between"
                                            }, [
                                                _createElementVNode("span", null, "MwSt. " + _toDisplayString(taxRate) + "%", 1 /* TEXT */),
                                                _createElementVNode("span", null, _toDisplayString(formatPrice(data.taxAmount)), 1 /* TEXT */)
                                            ]));
                                        }), 128 /* KEYED_FRAGMENT */)),
                                        (displayTaxCalculation.value)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                                _cache[15] || (_cache[15] = _createElementVNode("span", null, "Gesamt MwSt", -1 /* CACHED */)),
                                                _createElementVNode("span", null, _toDisplayString(formatPrice(displayTaxCalculation.value.totalTax)), 1 /* TEXT */)
                                            ]))
                                            : _createCommentVNode("v-if", true)
                                    ])
                                ]))
                                : _createCommentVNode("v-if", true),
                            _createElementVNode("div", _hoisted_49, [
                                _cache[16] || (_cache[16] = _createElementVNode("span", null, "Gesamt", -1 /* CACHED */)),
                                _createElementVNode("span", null, _toDisplayString(formatPrice(displayTotalAmount.value)), 1 /* TEXT */)
                            ])
                        ])
                    ])
                ])
            ]));
        };
    }
});
